import PricingPage_B from "@/components/pages/pricing-b/pricing-page-b";
import { useABTestPricePageContext } from "@/providers/ab-testing-providers/ab-test-pricing-page-provider";
import PricingPage_A from "@/components/pages/pricing-a/pricing-page-a";
import Loader from "@/components/common/loader";

const ABTestPricingPage = () => {
  return <PricingPage_A />;
  // const { variant, isLoading } = useABTestPricePageContext();
  // if (isLoading) {
  //   return <Loader />;
  // }
  //
  // if (!variant || variant === "pricing-a") {
  //   return <PricingPage_A />;
  // }
  //
  // return <PricingPage_B />;
};

export default ABTestPricingPage;
